import React, { useState, useEffect } from "react";
import icon1 from "../../../assets/social-security-icons/social-security-vs-70.svg";
import timeIcon from "../../../assets/social-security-icons/time-remaing-retirement.svg";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import backIcon from "../../../assets/social-security-icons/backIcon.svg";
import { SocialSecurityFormFields } from "./SocialSecurityFormFields";
import { NumberCardSkeleton } from "../../Skeletons/DebtSkeleton";
import { Table } from "antd";
import { useHistory } from "react-router-dom";
import "../styles/socialSecurity.css";
import { SocialSecurityHardCodeFields } from "./SocialSecurityHardCodeFields";
import {
  calculateSSRow,
  generateAtAge70SSTable,
} from "../../../helpers/EarlyvsAtAge70Calculations";
import { MODULE_API } from "../../../apis";
import { calculateSocialSecurityResults } from "../../../helpers/socialSecurityCalculations";
import { calculateRetirementAge } from "../../../helpers/EarlyvsFRACalculation";
import { formatCurrencyAmount } from "../../../helpers/formatAmount";
import { SocialSecurityFormSkeleton } from "../../InsuranceNew/InsuraceDashboardComponents/SocialSecurityFormSkeleton";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import CombinedSocialSecurityTable from "./CombinedSocialSecurityTable";
export const SocialSecurityEarly70 = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [results, setResults] = useState(null);
  const [userEntryResults, setUserEntryResults] = useState(null);
  const [socialFieldsData, setSocialFieldsData] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [loadingAttributes, setLoadingAttributes] = useState(false);
  const [attributes, setAttributes] = useState(null);
  const module = "Social Security vs Age 70";
  const moduleDataToFetch = "Social Security Calculator";

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formFields = [
    {
      label: "Enter years",
      type: "number",
      name: "years",
    },
    {
      label: "Enter months",
      type: "number",
      name: "months",
    },
  ];
  const resultArray = [
    {
      id: 1,
      name: "Time until Full Retirement Age",
      icon: timeIcon,
      value:
        formData && formData["Enter Years"]
          ? calculateRetirementAge(
              formData["Enter Years"],
              formData["Enter Months"] || 0
            )
          : "N/A",
    },
  ];

  const columns = [
    {
      title: "Age to take Social Security",
      dataIndex: "Age to take Social Security",
      key: "Age to take Social Security",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Months from Full Retirement Age",
      dataIndex: "Months from Full Retirement Age",
      key: "Months from Full Retirement Age",
      render: (record) => (record ? record : "0"),
    },
    {
      title: "% of FRA Benefit",
      dataIndex: "% of FRA Benefit",
      key: "% of FRA Benefit",
      render: (record) => (record ? `${record + "%"} ` : "N/A"),
    },
    {
      title: "Monthly Benefit",
      dataIndex: "Monthly Benefit",
      key: "Monthly Benefit",
      render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
    },
    {
      title: (
        <div className="social-security-table-heading">
          Information without TVM Interest
        </div>
      ),
      children: [
        {
          title: "Total benefit received up to Age 70",
          dataIndex: "Total benefit received up to Age 70",
          key: "Total benefit received up to Age 70",
          render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
        },
        {
          title: "Months to break-even with age 70",
          dataIndex: "Months to break-even with age 70",
          key: "Months to break-even with age 70",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Age at Break-even",
          dataIndex: "Age at Break-even-formated",
          key: "Age at Break-even-formated",
          render: (record) => (record ? record : "N/A"),
        },
      ],
    },
    {
      title: (
        <div className="social-security-table-heading">
          Information with TVM and COLA
        </div>
      ),
      children: [
        {
          title: "Future value at 70 of pre-70 benefit",
          dataIndex: "Future value at 70 of pre-70 benefit",
          key: "Future value at 70 of pre-70 benefit",
          render: (record) => (record ? formatCurrencyAmount(record) : "N/A"),
        },
        {
          title: "Months to break-even with age 70",
          dataIndex: "Months to break-even with age 70",
          key: "Months to break-even with age 70",
          render: (record) => (record ? record : "N/A"),
        },
        {
          title: "Age at Break-even",
          dataIndex: "Age at Break-even-COLA-formated",
          key: "Age at Break-even-COLA-formated",
          render: (record) => (record ? record : "N/A"),
        },
      ],
    },
  ];

  const allResults = [
    {
      id: 1,
      name: "Months before FRA",
      value: userEntryResults ? userEntryResults.monthsEarly : "N/A",
    },
    {
      id: 2,
      name: "% of FRA",
      value: userEntryResults
        ? userEntryResults["% of FRA Benefit"] + "%"
        : "N/A",
    },
    {
      id: 3,
      name: "Monthly benefit",
      value: userEntryResults
        ? formatCurrencyAmount(userEntryResults["Monthly Benefit"])
        : "N/A",
    },
    {
      id: 4,
      name: "Pre-FRA Benefit",
      value: userEntryResults
        ? formatCurrencyAmount(
            userEntryResults["Total benefit received up to Age 70"]
          )
        : "N/A",
    },
    {
      id: 5,
      name: "Months to break-even",
      value: userEntryResults
        ? userEntryResults["Months to break-even with age 70"]
        : "N/A",
    },
    {
      id: 6,
      name: "Age at break-even",
      value: userEntryResults
        ? userEntryResults["Age at Break-even"] &&
          parseFloat(userEntryResults["Age at Break-even"]).toFixed(2)
        : "N/A",
    },
    {
      id: 9,
      name: "Future Pre-FRA Benefit",
      value: userEntryResults
        ? formatCurrencyAmount(
            userEntryResults["Future value at 70 of pre-70 benefit"]
          )
        : "N/A",
    },
    {
      id: 10,
      name: "Months to break-even",
      value: userEntryResults
        ? userEntryResults["Months to break even with age 70 (TVM+COLA)"]
        : "N/A",
    },
    {
      id: 11,
      name: "Age at break-even",
      value: userEntryResults
        ? userEntryResults["Age at Break-even (TVM+COLA)"] &&
          parseFloat(userEntryResults["Age at Break-even (TVM+COLA)"]).toFixed(
            2
          )
        : "N/A",
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: moduleDataToFetch,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setSocialFieldsData(res.records[0]);
        const socialData = res.records[0];
        const resultsAll = calculateSocialSecurityResults(res.records[0]);
        setResults(resultsAll);
        return socialData;
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchModuleData = async (module, socialData) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setFormData(res.records[0]);
        const data = res.records[0];
        const FRA_YEARS = 67,
          FRA_MONTHS = 0;
        const START_YEARS = data["Enter Years"],
          START_MONTHS = data["Enter Months"];
        const FRA_BENEFIT =
          (socialFieldsData &&
            socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
          (socialData && socialData["Your Monthly Benefit at FRA ($)"]) ||
          0; // baseline at FRA
        const COLA = 0.02; // 2%
        const discountRate = 0.03;
        const lastResultData = calculateSSRow(
          START_YEARS,
          FRA_YEARS,
          FRA_BENEFIT,
          COLA,
          discountRate
        );
        setUserEntryResults(lastResultData);
        const tableDataAll = generateAtAge70SSTable(
          START_YEARS,
          FRA_YEARS,
          FRA_BENEFIT,
          COLA,
          discountRate
        ); // FRA = 67, FRA benefit = $2300
        console.log("tableDataAll", tableDataAll, lastResultData);
        setTableData(tableDataAll);
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Social Security fields
  const getFields = async (Name) => {
    setLoadingAttributes(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue
          );
        setAttributes(sortedAttributes);
      }
    } finally {
      setLoadingAttributes(false);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset(module, {
        clientModules: [formData],
      });
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      console.error("Error updating record", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAll = async () => {
    const socialData = await fetchData();
    await fetchModuleData(module, socialData);
  };
  useEffect(() => {
    getFields(module);
    fetchAll();
    // fetchData();
    // fetchModuleData(module);
  }, []);

  const handleCalculate = () => {
    if (!formData) return;

    if (formData && formData.id) {
      updateRecord();
    } else {
      createAttributes();
    }
    if (formData && formData["Enter Years"]) {
      const FRA_YEARS = 67,
        FRA_MONTHS = 0;
      const START_YEARS = formData["Enter Years"],
        START_MONTHS = formData["Enter Months"];
      const FRA_BENEFIT =
        (socialFieldsData &&
          socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
        0; // baseline at FRA
      const COLA = 0.02; // 2%
      const discountRate = 0.03;
      const lastResultData = calculateSSRow(
        START_YEARS,
        FRA_YEARS,
        FRA_BENEFIT,
        COLA,
        discountRate
      );
      setUserEntryResults(lastResultData);
      const tableDataAll = generateAtAge70SSTable(
        START_YEARS,
        FRA_YEARS,
        FRA_BENEFIT,
        COLA,
        discountRate
      ); // FRA = 67, FRA benefit = $2300
      console.log("tableDataAll", tableDataAll, lastResultData);
      setTableData(tableDataAll);
    }
  };
  return (
    <div className="social-security-main">
      <div
        className="social-security-back-container"
        onClick={() => {
          history.push("/planner/social-security");
        }}
      >
        <div className="social-security-back-icon-container">
          <img width={16} height={16} src={backIcon} alt={"back Icon"}></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-back-text">Back to Social Security</div>
      </div>
      <div className="social-security-main-heading-container">
        <div className="social-security-icon-container">
          <img
            width={32}
            height={32}
            src={icon1}
            alt={"Retirement Calculator"}
          ></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-main-heading">
          Social Security Early vs Starting at 70
          <ToolTipCreator name={"retirement_earnings_tooltip"} />
        </div>
      </div>
      <div className="social-security-calculator-content-main">
        <div className="social-security-calculator-content-form-container">
          <div className="social-security-sub-title">
            Enter age before 70 to take Social Security
          </div>
          {/*<SocialSecurityHardCodeFields
            formFields={formFields && formFields}
            formData={formData && formData}
            onChange={handleChange}
          /> */}
          {loadingAttributes ? (
            <SocialSecurityFormSkeleton rows={1} />
          ) : (
            <SocialSecurityFormFields
              formFields={attributes && attributes}
              formData={formData && formData}
              onChange={handleChange}
            />
          )}
          <button
            className="social-security-calculator-submit-button"
            onClick={(e) => {
              e.preventDefault();
              handleCalculate();
            }}
            disabled={loading || loadingAttributes || !formData}
          >
            Apply
          </button>
        </div>
        <div className="social-security-calculator-results">
          <h3>Results</h3>
          <div className="social-security-result-tag-container">
            {resultArray &&
              resultArray.map((item, index) => (
                <div
                  key={index}
                  className="social-security-main-heading-container"
                >
                  <div className="social-security-result-icon-container">
                    <img
                      width={32}
                      height={32}
                      src={item.icon}
                      alt={item.name}
                    ></img>
                  </div>
                  <div className="social-security-results-main">
                    <div className="social-result-heading">{item.name} </div>
                    <div className="social-result-value">
                      {loading ? <NumberCardSkeleton /> : item.value}{" "}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="retirement-calculator-main">
        <div className="social-security-main-heading-container">
          {/* {moduleData.name} */}
          <div className="social-security-main-heading">
            Breakdown of the results
          </div>
        </div>
        <div
          className="social-security-calculator-content-main"
          style={{ position: "relative" }}
        >
          <CombinedSocialSecurityTable
            tableData={tableData && tableData}
            cols={columns}
          />
          <NewLoader isLoading={loading} />
        </div>
        <div
          className="summary-section-container"
          style={{
            alignItems: "baseline",
            flexWrap: "wrap",
            borderRadius: "8px",
            gap: "8px",
          }}
        >
          <div style={{ minWidth: "fit-content", width: "17%" }}>
            <div
              className="summary-section"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
              }}
            >
              <div className="total-summary-section">
                <h2 className="total-summary">Results</h2>
              </div>
              <div className="average-budget-summary-section">
                <h2 className="average-budget-summary">Your Entry</h2>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              width: "82%",
            }}
          >
            {allResults &&
              allResults.map((item, index) => (
                <div
                  key={index}
                  className="amount-spend-section"
                  style={{
                    borderLeft: "1px solid #d1d5db",
                    padding: "8px",
                    width: "18%",
                    textAlign: "center",
                  }}
                >
                  <div className="amount-spend-title-section">
                    <h2 className="spend-amount-title">{item.name}</h2>
                  </div>
                  <div className="spend-amount-amount-section">
                    <h2 className="spend-amount-amount">
                      {loading ? <NumberCardSkeleton /> : item.value}
                    </h2>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
